import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-register-qutuf-result',
  templateUrl: './register-qutuf-result.component.html',
  styleUrls: ['./register-qutuf-result.component.scss']
})
export class RegisterQutufResultComponent implements OnInit {

    public thisID: number = 0;
    private sub: any;
    constructor(private route: ActivatedRoute) { }

    ngOnInit() {
        this.sub = this.route.params.subscribe(params => {
            this.thisID = +params['id'];
        });
    }

}
